import React from "react";

const ChatbotOverlay = ({ onClose, iframeSrc }) => {
  return (
    <div
      id="chatbackground"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 10000,
      }}
      onClick={onClose}>
      <div className="chatwindow" onClick={(e) => e.stopPropagation()}>
        <button className="closechatwindow" onClick={onClose}>
          <img
            src="https://jaano.ai/close.svg"
            alt="Close Chat"
            className="closeimg"
          />
        </button>
        <iframe
          title="chatbot"
          id="chatbot-iframe"
          src={iframeSrc}
          sandbox="allow-scripts allow-same-origin allow-popups"
          allow="microphone"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            zIndex: 10001,
          }}
          className="border-none"
        />
      </div>
    </div>
  );
};

export default ChatbotOverlay;
